import { combineReducers } from "redux";
import student from "./student";
import app from "./app";

export const appReducer = combineReducers({
    student,
    app
});
